import { get, writable } from "svelte/store";
import Analytics from "../../Analytics/Analytics";
import API from "../../API/API";
import AuthStore from "../../Auth/Store";
import LoadState from "../../Enums/LoadState";
import GeoHelper from "../../Helpers/GeoHelper";
import MapLayerGroup from "../../Map/Enums/MapLayerGroup";
import VisibilityState from "../../Map/Enums/VisibilityState";
import MapLayerManager from "../../Map/MapLayerManager";
import { Layout, Paint } from "../../Map/MapLayerStyles";
import MapStore from "../../Map/Store";
import Port from "./Port";

const initLayerData = () => {
	return {
		layers: [],
		visible: writable(true)
	};
};

const initToggleData = (name, urls, visible) => {
	return {
		name: name,
		urls: urls,
		results: writable([]),
		loaded: writable(false),
		visible: writable(visible)
	};
};
const PortsStore = {
	config: {

	},
	meta: {
		loadState: writable(LoadState.INIT),
		visible: writable(false),
		lastUpdated: writable(0),
		layer: []
	},
	toggleList: [],
	toggles: {
		wpi: initToggleData("World Port Index", [
			"ports?type=&source=A"
		], true),
		wpdOffshore: initToggleData("WPD - Offshore Terminals", [
			"ports?type=&source=B&type=O&limit=5000",
			"ports?type=&source=B&type=O&limit=5000&offset=5000"
		], false)
	},
	filters: {
		filterString: writable("")
	},
	results: {
		ports: writable([]),
		portsOpen: writable([])
	},
	actions: {
		init: () => {
			if (get(PortsStore.meta.loadState) !== LoadState.INIT) {
				return;
			}
			PortsStore.meta.loadState.set(LoadState.LOADING);
			PortsStore.toggleList.push(PortsStore.toggles.wpi);
			PortsStore.toggleList.push(PortsStore.toggles.wpdOffshore);

			for (let i = 0; i < PortsStore.toggleList.length; i++) {
				((i) => {
					PortsStore.toggleList[i].visible.subscribe((visible) => {
						if (visible) {
							if (!get(PortsStore.toggleList[i].loaded)) {
								PortsStore.actions.loadFor(PortsStore.toggleList[i]);
							}
							else {
								PortsStore.actions.updateList();
							}
						}
						else {
							PortsStore.actions.updateList();
						}
					});
				})(i);
			}

			PortsStore.helpers._addDataLayer("allports", "symbol", Layout.ports, Paint.ports, GeoHelper.emptyGeoJson());
			MapLayerManager.addLayerGroup(MapLayerGroup.PORTS, ["allports"], ["allports"]);

			PortsStore.actions.loadFor(PortsStore.toggles.wpi).then(() => {
				PortsStore.meta.loadState.set(LoadState.LOADED);
				PortsStore.actions.updateList();
			});
		},
		loadFor: (toggleData) => {
			const requests = toggleData.urls.map((url) => {
				return API.get(url);
			});
			return Promise.all(requests).then((responses) => {
				PortsStore.actions.initFrom(toggleData, responses);
				PortsStore.actions.updateList();
			});
		},
		initFrom: (toggleData, responses) => {
			const ports = [];
			for (let r = 0; r < responses.length; r++) {
				const portsRaw = responses[r];
				const propertyKeys = Object.keys(portsRaw.headers);
				for (let i = 0; i < portsRaw.data.length; i++) {
					let feature = GeoHelper.featureAt(0, 0);
					for (let j = 0; j < propertyKeys.length; j++) {
						feature.properties[propertyKeys[j]] = portsRaw.data[i][portsRaw.headers[propertyKeys[j]]];
					}
					feature.geometry.coordinates = [
						feature.properties.LONGITUDE,
						feature.properties.LATITUDE
					];
					feature.properties.PORT_NAME = (feature.properties.SOURCE.trim() === "A") ? feature.properties.PORT_NAME_WPI : feature.properties.PORT_NAME_WPD;
					const port = new Port(feature);
					ports.push(port);
					feature = null;
				}
			}
			toggleData.results.set(ports);
			toggleData.loaded.set(true);
		},
		updateList: () => {
			let ports = [];
			for (let i = 0; i < PortsStore.toggleList.length; i++) {
				if (get(PortsStore.toggleList[i].loaded) && get(PortsStore.toggleList[i].visible)) {
					ports = [
						...ports,
						...get(PortsStore.toggleList[i].results)
					];
				}
			}
			PortsStore.results.ports.set(ports);

			PortsStore.actions.updateFeatureCollection();
			PortsStore.actions.updateVisibility();
			PortsStore.meta.lastUpdated.set(Date.now());
		},
		updateVisibility: () => {
			const map = MapStore.helpers.getMap();
			if (map) {
				if (get(PortsStore.meta.loadState) !== LoadState.LOADED) {
					return;
				}
				const visible = get(PortsStore.meta.visible);
				map.setLayoutProperty("allports", "visibility", (visible) ? VisibilityState.VISIBLE : VisibilityState.NONE);
			}
		},
		updateFeatureCollection: () => {
			const featureCollection = GeoHelper.emptyGeoJson();
			const ports = get(PortsStore.results.ports);
			for (let i = 0; i < ports.length; i++) {
				if (get(ports[i].visible)
				) {
					featureCollection.features.push(ports[i].asFeature());
				}
			}
			const map = MapStore.helpers.getMap();
			if (map) {
				const source = map.getSource("allports");
				if (source) {
					source.setData(featureCollection);
				}
			}
		},
		openPort: (portObj) => {
			Analytics.event("open_port_" + portObj.name, { category: "Ports", username: get(AuthStore.userInfo).username, portName: portObj.name });

			const list = get(PortsStore.results.portsOpen);
			const index = PortsStore.actions.findPortIndex(portObj);
			if (index >= 0) {
				return;
			}
			PortsStore.results.portsOpen.set([
				...list,
				{
					port: portObj,
					tab: "Info",
					loadState: LoadState.INIT,
					data: null
				}
			]);
		},
		findPortIndex: (portObj) => {
			const list = get(PortsStore.results.portsOpen);
			// return list.indexOf(portObj);
			for (let i = 0; i < list.length; i++) {
				if (list[i].port === portObj) {
					return i;
				}
			}
			return -1;
		},
		closePort: (portObj) => {
			const list = get(PortsStore.results.portsOpen);
			const index = PortsStore.actions.findPortIndex(portObj);
			if (index === -1) {
				return;
			}
			list.splice(index, 1);
			PortsStore.results.portsOpen.set(list);
		},
		gotoPort: (portObj) => {
			MapStore.helpers.zoomToPoint([portObj.lng, portObj.lat], 9);
		},
		loadPortStats: (portObj) => {
			return new Promise((resolve, reject) => {
				const portId = portObj.id;
				const portName = portObj.name.toUpperCase() + "_" + portObj.locode;
				const loadState = get(portObj.loadState);
				if (loadState === LoadState.INIT) {
					portObj.loadError.set("");
					portObj.loadState.set(LoadState.LOADING);
					API.get("ports/stats?id=" + portId)
						.then((result) => {
							portObj.stats = result.data;
							portObj.statsRolling = result.rolling;
							portObj.loadState.set(LoadState.LOADED);
							resolve();
						})
						.catch((err) => {
							console.error("err", err);
							portObj.loadError.set(err);
							portObj.loadState.set(LoadState.INIT);
							reject(err);
						});
				}
			});
		}
	},
	helpers: {
		_addDataLayer: (name, type, layout, paint, featureCollection, addToArray = null) => {
			MapStore.helpers.addDataLayer(name, type, layout, paint, featureCollection, PortsStore.meta.layers);
		},
		geocoderSearch: (query) => {
			const ports = get(PortsStore.results.ports);
			const matchingFeatures = [];
			for (let i = 0; i < ports.length; i++) {
				const port = ports[i];
				// handle queries with different capitalization than the source data by calling toLowerCase()
				if (port.nameAndTypeReadable.toLowerCase().search(query.toLowerCase()) !== -1) {
					const feature = {};
					feature.place_name = port.nameAndTypeReadable;
					feature.center = port.coordinates;
					feature.place_type = port.portTypeReadable;
					matchingFeatures.push(feature);
				}
			}
			return matchingFeatures;
		},
		searchByLocode: (locode, limit = -1) => {
			locode = locode.toLowerCase();
			const ports = get(PortsStore.results.ports);
			const results = [];
			for (let i = 0; i < ports.length; i++) { // TODO: use algorithm library for this,.
				const port = ports[i];
				if (port.locode && port.locode.toLowerCase().startsWith(locode)) {
					results.push(port);
					if (limit !== -1 && results.length >= limit) {
						break;
					}
				}
			}
			return results;
		}
	}
};

export default PortsStore;
